module.exports = __webpack_public_path__ + "white_arrow_down.png";